import React from 'react';
import { useLocation } from 'react-router-dom';

import { Features } from '@/features';

import DashboardLayout from '../src/common/components/Dashboard/DashboardLayout';
import { signOut, useAuthContext } from './auth';

export const LayoutContainer = ({
    children,
    useFullPageNavigation,
}: {
    children: React.ReactChild[] | React.ReactChild;
    useFullPageNavigation?: boolean;
}) => {
    const location = useLocation();
    const { userData, isEnabled } = useAuthContext();

    return (
        <DashboardLayout
            currentRoute={location.pathname}
            userName={userData?.name ?? ''}
            onSignOutClick={signOut}
            showSavedTemplates={isEnabled(Features.SAVE_SESSION_TEMPLATES)}
            showTemplatePrograms={isEnabled(Features.SAVE_SESSION_TEMPLATES)} // MK20231003 TODO: perms to show tempalte programs
            useFullPageNavigation={useFullPageNavigation}
        >
            {children}
        </DashboardLayout>
    );
};
